<template>
  <div>
    <div v-bind:data-kt-indicator="loading ? 'on' : 'off'">
      <span class="indicator-progress">
        Aguarde, carregando...
        <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
      </span>
    </div>
    <div
      v-if="this.errosGerais.Message && !loading"
      class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6 me-lg-10"
      ref="errosGerais"
    >
      <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
        <inline-svg src="media/icons/duotune/general/gen044.svg" />
      </span>
      <div class="d-flex flex-stack flex-grow-1">
        <div class="fw-bold">
          <h4 class="text-gray-800 fw-bolder">Aviso</h4>
          <div class="fs-6 text-gray-600">
            {{ this.errosGerais.Message }}
          </div>
        </div>
      </div>
    </div>
    <div v-if="!loading" class="d-flex flex-column flex-xl-row">
      <div class="flex-column flex-lg-row-auto mb-7 me-lg-10 w-100 w-xl-400px">
        <div class="card card-flush py-5">
          <div class="card-header">
            <div class="card-title">
              <img src="media/icons/duotune/general/gen046.svg" class="me-2" />
              <h2>Ajuda</h2>
            </div>
            <div class="card-title">
              <div class="d-flex align-items-center position-relative my-1">
                <span class="svg-icon svg-icon-1 position-absolute ms-6">
                  <inline-svg src="media/icons/duotune/general/gen004.svg" />
                </span>
                <input
                  type="text"
                  id="txtPesquisar"
                  v-model="pesquisa"
                  @input="onSearch($event.target.value)"
                  class="form-control form-control-solid w-100 ps-15"
                  placeholder="Pesquisar Ajuda"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div
              v-if="loading"
              class="overlay-layer card-rounded bg-dark bg-opacity-5"
            >
              <div class="spinner-border text-primary" role="status"></div>
              <span class="ms-2">Aguarde, carregando...</span>
            </div>
            <div v-else class="custom-tree-container border p-2">
              <el-tree
                class="custom-tree"
                ref="treeAjuda"
                :data="this.ajudas"
                :expand-on-click-node="false"
                :filter-node-method="filterNode"
                :empty-text="emptyText"
                :highlight-current="true"
                default-expand-all
                @node-click="selecionarRegistro($event)"
              >
                <template #default="{ data, node }">
                  <div
                    class="prevent-select"
                    @dblclick="carregarAjuda(this.ajudaAtual.id)"
                  >
                    <span
                      v-if="data.categoria || data.modulo"
                      class="svg-icon svg-icon-1 me-3 svg-icon-warning"
                    >
                      <inline-svg src="media/icons/duotune/files/fil012.svg"
                    /></span>
                    <span v-else class="svg-icon svg-icon-1 me-3">
                      <inline-svg src="media/icons/duotune/files/fil003.svg"
                    /></span>
                    <span class="custom-tree-node">
                      <span>{{ node.label }}</span>
                    </span>
                  </div>
                </template>
              </el-tree>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
        <div class="card card-flush p-5">
          <div
            v-if="
              this.ajudaAtual && this.ajudaAtual.id && this.ajudaAtual.id > 0
            "
            class="card-body p-2"
          >
            <div class="d-flex flex-wrap flex-sm-nowrap mb-3">
              <div class="flex-grow-1">
                <div
                  class="d-flex justify-content-between align-items-start flex-wrap mb-2"
                >
                  <div
                    v-if="this.ajudaAtual.imagem ? this.ajudaAtual.imagem : ''"
                    class="symbol symbol-50px"
                  >
                    <div
                      class="symbol-label fs-2 fw-bold bg-light-dark"
                      :style="{
                        'background-image': `url(${
                          this.$utils.getUrl() + this.ajudaAtual.imagem
                        })`,
                      }"
                    ></div>
                  </div>
                  <div v-else class="symbol symbol-50px">
                    <div
                      :class="[
                        'symbol-label fs-2 fw-bold ' +
                          this.$utils.getColorRandom(),
                      ]"
                    >
                      {{
                        this.ajudaAtual.label
                          ? this.ajudaAtual.label.substring(0, 1).toUpperCase()
                          : ""
                      }}
                    </div>
                  </div>
                  <div class="ms-6 d-flex flex-column mb-4">
                    <div class="fw-bold">
                      <div class="text-gray-800 fw-bolder">
                        {{ this.ajudaAtual.label }}
                      </div>
                      <p class="fs-7 quebra-texto text-gray-600 mt-2">
                        {{ this.ajudaAtual.assunto }}
                      </p>
                    </div>
                  </div>
                  <div
                    class="d-flex flex-wrap flex-row-fluid justify-content-end gap-5"
                  >
                    <button
                      class="btn btn-primary svg-icon-white"
                      @click="this.carregarAjuda(this.ajudaAtual.id)"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/arrows/arr027.svg"
                          class="me-2"
                        />Abrir
                      </span>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-else
            class="notice d-flex bg-light-info rounded border-info border border-dashed my-5 p-6"
          >
            <span class="svg-icon svg-icon-2tx svg-icon-info me-4">
              <inline-svg src="media/icons/duotune/general/gen044.svg" />
            </span>
            <div class="d-flex flex-stack flex-grow-1">
              <div class="fw-bold">
                <div class="text-gray-800 fw-bolder">
                  Nenhuma ajuda selecionada
                </div>
                <div class="fs-7 text-gray-600 mt-2">
                  Selecione uma ajuda para visualizar
                </div>
              </div>
            </div>
          </div>
          <div
            class="hover-scroll-x"
            v-if="this.ajudasAbertas && this.ajudasAbertas.length > 0"
          >
            <div class="d-grid p-0">
              <ul class="nav nav-tabs flex-nowrap text-nowrap">
                <li
                  v-for="ajudaAberta in ajudasAbertas"
                  :key="ajudaAberta.guid"
                  class="nav-item position-relative d-flex align-items-center"
                  :ref="'nav' + ajudaAberta.guid"
                >
                  <a
                    @click="selecionarAba(ajudaAberta)"
                    :class="[
                      'nav-link btn btn-active-light btn-color-gray-600 btn-active-color-primary rounded-bottom-0',
                      {
                        active: ajudaAberta.guid === this.ajudaAberta.guid,
                      },
                    ]"
                  >
                    {{ ajudaAberta.label }}
                    <button
                      @click="fecharAba(ajudaAberta)"
                      type="button"
                      class="btn-close ms-2"
                      aria-label="Close"
                    ></button>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div class="tab-content" ref="tabContent">
            <div
              v-for="ajudaAberta in ajudasAbertas"
              :key="ajudaAberta.guid"
              class="tab-pane fade"
              :class="{
                'show active': ajudaAberta.guid === this.ajudaAberta.guid,
              }"
              :id="ajudaAberta.guid"
              role="tabpanel"
            >
              <div class="card-body m-0 p-5 view-html">
                <ExibirAjudaModal
                  :modal="false"
                  :ref="'htmlViewer' + ajudaAberta.guid"
                  :ajuda="ajudaAberta"
                ></ExibirAjudaModal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <LoadingModal
    :nomeRef="'loadingModalCarregarAjuda'"
    :mensagem="this.mensagemLoadingCarregar"
    v-if="this.loadingCarregarAjuda === true"
  ></LoadingModal>
</template>

<script>
import ExibirAjudaModal from "@/views/ajuda/ExibirAjudaModal.vue";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";

export default {
  components: {
    LoadingModal,
    ExibirAjudaModal,
  },
  methods: {
    async scrollNav(refName) {
      let el = this.$refs[refName];
      if (el) {
        el[0].scrollIntoView({
          behavior: "smooth",
        });
      }
    },
    onSearch(pesquisa) {
      this.$refs.treeAjuda.filter(pesquisa);
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      } else {
        return data.label
          .toUpperCase()
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .includes(
            value
              .toUpperCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
      }
    },
    async carregarAjudas() {
      try {
        this.ajudas = [];

        var ret = await this.$store.dispatch("ajuda/getAjudasUsuario");

        if (ret.Success == true) {
          let result = ret.Data;

          const ajd = result.map((categoria) => ({
            label: categoria.Categoria,
            categoria: categoria.Categoria,
            children: categoria.Modulos.map((modulo) => ({
              label: modulo.Modulo,
              modulo: modulo.Modulo,
              children: modulo.Ajudas.map((ajuda) => ({
                label: ajuda.descricao,
                id: ajuda.id,
                assunto: ajuda.assunto,
                imagem: ajuda.imagem,
              })),
            })),
          }));

          this.ajudas = ajd;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async selecionarRegistro(ajuda) {
      this.ajudaAtual = ajuda;
    },
    selecionarAba(ajuda) {
      const index = this.ajudasAbertas.findIndex((a) => a.guid === ajuda.guid);
      if (index !== -1) {
        this.ajudaAberta = { ...ajuda };
      }
    },
    async carregarAjuda() {
      this.mensagemLoadingCarregar = "Aguarde, carregando ajuda...";
      await this.exibirModalLoadingCarregar(true);
      try {
        if (this.ajudaAtual) {
          var ret = await this.$store.dispatch(
            "ajuda/getAjuda",
            this.ajudaAtual.id
          );

          if (ret.Success == true) {
            await this.exibirModalLoadingCarregar(false);
            var ajudaData = ret.Data;
            ajudaData.conteudo = ajudaData.conteudo.replace(
              new RegExp("/uploads/Ajuda", "g"),
              this.$utils.getUrl() + "/uploads/Ajuda"
            );
            setTimeout(() => {
              const ajdComGuid = {
                ...this.ajudaAtual,
                guid: this.$utils.generateUuidv4(),
                conteudo: ajudaData.conteudo,
                imagem: ajudaData.imagem,
              };
              this.ajudasAbertas.push(ajdComGuid);
              this.ajudaAberta = ajdComGuid;
            }, 200);

            setTimeout(() => {
              this.scrollNav("nav" + this.ajudaAberta.guid);
            }, 1000);
          }
        }
      } catch (error) {
        await this.exibirModalLoadingCarregar(false);
        console.log(error);
      }
    },

    fecharAba(ajuda) {
      const index = this.ajudasAbertas.findIndex((a) => a.guid === ajuda.guid);
      if (index !== -1) {
        this.ajudasAbertas.splice(index, 1);
      }
      if (this.ajudasAbertas.length > 0) {
        this.ajudaAberta = {
          ...this.ajudasAbertas[this.ajudasAbertas.length - 1],
        };
      } else {
        this.ajudaAberta = null;
      }
    },
    async exibirModalLoadingCarregar(exibir, callback) {
      if (exibir === true) {
        this.loadingCarregarAjuda = true;
        getOrCreateInstanceModal(
          "loadingModalCarregarAjuda",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalCarregarAjuda", () => {
          this.loadingCarregarAjuda = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async mounted() {
    this.loading = true;
    await this.carregarAjudas();
    this.loading = false;
  },
  data() {
    return {
      loading: false,
      errosGerais: {},
      ajudas: [],
      pesquisa: "",
      emptyText: "Nenhuma ajuda encontrada",
      ajudaAtual: null,
      ajudaAberta: null,
      ajudasAbertas: [],
      mensagemLoadingCarregar: "",
      loadingCarregarAjuda: false,
    };
  },
};
</script>

<style>
.custom-tree-node {
  white-space: normal;
  line-height: 1.3;
}
.custom-tree >>> .el-tree-node__content {
  height: auto;
}

.quebra-texto {
  white-space: pre-line;
}

.prevent-select {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -khtml-user-select: none;
  -ms-user-select: none;
}

.view-html {
  padding: 6px;
  background-color: #ccc;
}
</style>
